import axios from 'axios';

// declare dynamic selectors
let el = selector => document.querySelector(selector);
let eachEl = selector => document.querySelectorAll(selector);

// init submit form event
eachEl('[data-ajaxform]').forEach((el) => el.addEventListener('submit', submitForm));

// submit form functionality
export function submitForm(e) {
  e.preventDefault();
  let formId = e.target.closest('.form').getAttribute('id');
  let formEl = el(`#${formId}`);
  formEl.classList.add('form--loading');

  // Prepareing form data
  let formData = new FormData(e.target);

  // Attaching uploaded files
  let fileInputElement = formEl.querySelector('input[name="attachments[]"]');
  if(fileInputElement) {
    Array.from(fileInputElement.files).forEach(file => formData.append("attachments[]", file));
  }

  // Sending data to server
  axios({
    method: "POST",
    url: e.target.getAttribute('action'),
    headers: {
      'Content-Type': 'multipart/form-data',
      'X-CSRF-TOKEN': el('meta[name="csrf-token"]').getAttribute('content'),
      'X-Requested-With': 'XMLHttpRequest',
    },
    data: formData
  }).then(res => {
    // Handle form success
    if(res.data.msg.reloadPage  !== undefined) {
      window.location.reload();
    } else {
      formEl.classList.remove('form--loading');
      formEl.classList.add('form--finished');
      formEl.querySelector('.form__alertSuccess').textContent = res.data.msg;
    }


  })
    .catch((error) => {
      formEl.classList.remove('form--loading');
      if (error.response.status == 422) {
        // Handle validation errors
        formEl.querySelectorAll('.is-invalid').forEach(input => input.classList.remove('is-invalid'));
        formEl.querySelectorAll('.invalid-feedback').forEach(inputFeedback => inputFeedback.textContent = '');
        
        let errors = error.response.data.errors;
        Object.keys(errors).forEach(key => {
          formEl.querySelectorAll(`input[name="${key}"], input[name="${key}[]"], select[name="${key}"]`)
                .forEach(input => input.classList.add('is-invalid'));
                
          let errorResult = errors[key].join();
          let invalidFeedbackEl = formEl.querySelector(`input[name="${key}"] + .invalid-feedback, select[name="${key}"] + .invalid-feedback`)
          if(invalidFeedbackEl) {
            invalidFeedbackEl.textContent = errorResult;
          }
        });
      } else {
        // Handle general errors
        formEl.classList.add('form--error');
      }
    });
}



// WEBPACK FOOTER //
// ./resources/js/frontend/ajax-form.js